import React from 'react';
import '../components-css/footer.scss'
import '../components-css/sales.scss'
import MiniHeaders from "./mini-headers";
import ImageCarousel from "./image-carousel";

function getSalesImagesNamesList(){
    const list = [];
    for (let i = 1; i < 8; i++) {
        list.push(`sales-image-${i}`)
    }
    return list;
}


const Sales = () => {
    return (
        <div>
            <div className={'wrapper blocks-wrapper'}>
                <MiniHeaders headerName={'Վաճառքներ'}/>

                <div>
                <ImageCarousel items={getSalesImagesNamesList()}/>
                </div>
            </div>
        </div>

    );
};

export default Sales;

